import Effect from '../Effect';
class AudioEffect extends Effect {
}
export default AudioEffect;
//# sourceMappingURL=AudioEffect.js.map